function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { ModalItemProvider } from "./item-context";
import { useModalManager } from "./use-modal-manager";
const ModalContext = /*#__PURE__*/createContext(null);
export function ModalProvider(_ref) {
  let children = _ref.children,
    backdrop = _ref.backdrop,
    loading = _ref.loading,
    modal = _ref.modal;
  const modalManager = useModalManager();
  return _jsxs(ModalContext.Provider, {
    value: modalManager,
    children: [children, _jsx(Modals, {
      backdrop: backdrop,
      loading: loading,
      modal: modal
    })]
  });
}
function Modals(_ref2) {
  let backdrop = _ref2.backdrop,
    loading = _ref2.loading,
    modal = _ref2.modal;
  const modalManager = useModals();
  const stack = modalManager.stack,
    isLoading = modalManager.isLoading;
  return _jsxs(_Fragment, {
    children: [isLoading && loading && loading(modalManager), stack.map(modalInstance => _jsx(ModalItemProvider, {
      modal: modalInstance,
      children: modal ? modal(modalInstance, modalManager) : _jsx(modalInstance.component, _objectSpread(_objectSpread({}, modalInstance.props), {}, {
        close: modalInstance.close,
        isOpen: modalInstance.isOpen,
        id: modalInstance.id,
        index: modalInstance.index
      }))
    }, modalInstance.id)), (isLoading || stack.length > 0) && backdrop && backdrop(modalManager)]
  });
}
export function useModals() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModals must be used within a ModalProvider");
  }
  return context;
}